var footer = 'fx_2d2fb1e5_5qmtwv0';

export { footer };
//# sourceMappingURL=footer.vanilla.mjs.map
